var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1542 8.49924L11.0914 0.246337C11.0144 0.168281 10.9229 0.106326 10.822 0.0640469C10.7212 0.0217675 10.613 0 10.5037 0C10.3945 0 10.2863 0.0217675 10.1854 0.0640469C10.0846 0.106326 9.99303 0.168281 9.91609 0.246337L0.853224 8.49924C0.701007 8.60638 0.58904 8.76194 0.535338 8.94088C0.481636 9.11981 0.489322 9.31172 0.557159 9.48573C0.624996 9.65974 0.74904 9.80573 0.909331 9.9002C1.06962 9.99468 1.25684 10.0321 1.44086 10.0066H3.0548V19.1672C3.0548 19.3881 3.142 19.5999 3.29721 19.7561C3.45243 19.9123 3.66295 20 3.88245 20H17.125C17.3445 20 17.555 19.9123 17.7102 19.7561C17.8655 19.5999 17.9527 19.3881 17.9527 19.1672V10.0066H19.608C19.7882 10.0207 19.9681 9.97511 20.1201 9.8767C20.2722 9.77829 20.388 9.6325 20.4499 9.46161C20.5118 9.29072 20.5165 9.10412 20.4631 8.93034C20.4097 8.75656 20.3012 8.60514 20.1542 8.49924ZM16.2973 14.1705H4.71011V10.0066H16.2973V14.1705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorIcon);
export default __webpack_public_path__ + "static/media/floor-icon.0a55bc6a2faecd378a9856520a3357be.svg";
export { ForwardRef as ReactComponent };